<template>
	<div class="wrapper" :class="[{'nav-open': $sidebar.showSidebar}]">
		<notifications></notifications>
		<side-bar v-if="role === 'ADMIN'" title="viva ok" :auto-close="false" logo="/img/logo.png">
			<mobile-menu></mobile-menu>
			<template slot-scope="props" slot="links">
			<sidebar-item :link="{name: 'Visão geral', icon: 'timeline', path: '/visao-geral'}"></sidebar-item>

			<sidebar-item :link="{name: 'Relatórios de acesso', icon: 'report', path: '/relatorios'}"></sidebar-item>

			<sidebar-item :link="{name: 'Contatos', icon: 'contact_support', path: '/contatos'}"></sidebar-item>

			<sidebar-item :link="{name: 'Respostas', icon: 'assignment_turned_in', path: '/respostas'}"></sidebar-item>

			<sidebar-item style="margin-bottom: 45px;" :link="{name: 'Srq20 E-mails', icon: 'find_in_page', path: '/srq20-emails'}"></sidebar-item>

			<sidebar-item :link="{name: 'Empresas', icon: 'business', path: '/empresas'}"></sidebar-item>

			<sidebar-item :link="{name: 'Categorias', icon: 'format_list_bulleted', path: '/categorias'}"></sidebar-item>

			<sidebar-item :link="{name: 'Manuais', icon: 'library_books', path: '/manuais'}"></sidebar-item>

			<sidebar-item :link="{name: 'Artigos', icon: 'bookmark', path: '/artigos'}"></sidebar-item>

			<sidebar-item :link="{name: 'Cursos', icon: 'bookmarks', path: '/cursos'}"></sidebar-item>

			<sidebar-item :link="{name: 'Vídeos', icon: 'movie', path: '/videos'}"></sidebar-item>

			<sidebar-item :link="{name: 'Chats', icon: 'chat', path: '/chats',
				sub: $root.$data.pendingChat ? `${$root.$data.pendingChat} pendentes` : null }"></sidebar-item>

			<sidebar-item style="margin-bottom: 45px;" :link="{name: 'Podcasts', icon: 'audiotrack', path: '/podcasts'}"></sidebar-item>


			<sidebar-item :link="{name: 'Lgpd', icon: 'lock', path: '/lgpd'}"></sidebar-item>

			<sidebar-item :link="{name: 'Usuários', icon: 'person', path: '/usuarios'}"></sidebar-item>

			<sidebar-item :link="{name: 'Especialistas', icon: 'assignment_ind', path: '/especialistas'}"></sidebar-item>

			<sidebar-item :link="{name: 'Administradores', icon: 'settings', path: '/administradores'}"></sidebar-item>

			</template>
		</side-bar>

		<side-bar v-if="role === 'SPECIALIST'" title="viva ok" :auto-close="false" logo="/img/logo.png">
			<mobile-menu></mobile-menu>
			<template slot-scope="props" slot="links">
				<sidebar-item :link="{name: 'Visão geral', icon: 'timeline', path: '/visao-geral'}"></sidebar-item>

				<sidebar-item :link="{name: 'Chats', icon: 'chat', path: '/chats',
					sub: $root.$data.pendingChat ? `${$root.$data.pendingChat} pendentes` : null}"></sidebar-item>

				<sidebar-item :link="{name: 'Editar dados', icon: 'person', path: `/especialista/${id}`}"></sidebar-item>
			</template>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
				<zoom-center-transition :duration="200" mode="out-in">
					<!-- your content here -->
					<router-view></router-view>
				</zoom-center-transition>
			</div>
			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		new PerfectScrollbar(`.${className}`);
	} else {
		// try to init it later in case this component is loaded async
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

import TopNavbar from "./DashboardLayoutComponents/TopNavbar.vue";
import ContentFooter from "./DashboardLayoutComponents/ContentFooter.vue";
import DashboardContent from "./DashboardLayoutComponents/Content.vue";
import MobileMenu from "./DashboardLayoutComponents/MobileMenu.vue";
import UserMenu from "./DashboardLayoutComponents/UserMenu.vue";
import Session from "@/models/session.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";

export default {
	components: {
		TopNavbar,
		ContentFooter,
		DashboardContent,
		MobileMenu,
		UserMenu,
		SlideYDownTransition,
		ZoomCenterTransition,
		Session,
	},
	data() {
		return {
			pendingChat: '',
		}
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		}
	},
	computed: {
		role: () => Session.getItem("role"),
		id: () => Session.getItem("id"),
	},
	mounted() {
		let docClasses = document.body.classList;
		let isWindows = navigator.platform.startsWith("Win");
		if (isWindows) {
			// if we are on windows OS we activate the perfectScrollbar function
			initScrollbar("sidebar");
			initScrollbar("sidebar-wrapper");

			docClasses.add("perfect-scrollbar-on");
		} else {
			docClasses.add("perfect-scrollbar-off");
		}
	},
	created() {}
};
</script>

<style lang="scss">
	$scaleSize: 0.95;
	@keyframes zoomIn95 {
		from {
			opacity: 0;
			transform: scale3d($scaleSize, $scaleSize, $scaleSize);
		}
		to {
			opacity: 1;
		}
	}
	.main-panel .zoomIn {
		animation-name: zoomIn95;
	}
	@keyframes zoomOut95 {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
			transform: scale3d($scaleSize, $scaleSize, $scaleSize);
		}
	}
	.main-panel .zoomOut {
		animation-name: zoomOut95;
	}

	.logo-img img {
		width: 60% !important;
		padding-bottom: 2px;
	}

	.sidebar .nav p {
		font-size: 1rem;
		color: white;
	}

	.sidebar .nav span {
		color: white;
	}

	.sidebar .md-icon.md-theme-default.md-icon-font {
		color: white !important;
	}

	a.router-link-active > p,
	a.router-link-active > span {
		color: #ffffff !important;
	}

</style>


